import VehiculesController from './vehicules.controller';

export default {
    template: require('./vehicules.tpl.html'),
    controller: VehiculesController
};
